import { PageHeader } from "@sylviq/ui-react-web/components/ui/page-header";
import { Tabs } from "@sylviq/ui-react-web/components/ui/tabs";
import { useViewSearch } from "@/lib/view-search";
import { AllowancesTab } from "@/features/tax/AllowancesTab";
import { BracketsTab } from "@/features/tax/BracketsTab";
import { LookupTab } from "@/features/tax/LookupTab";
import { RatesTab } from "@/features/tax/RatesTab";

const SECTIONS = [
  { value: "rates", label: "Rates" },
  { value: "brackets", label: "Brackets" },
  { value: "allowances", label: "Allowances" },
  { value: "lookup", label: "Lookup" },
];

export function TaxSettingsPage({ embedded = false }: { embedded?: boolean } = {}) {
  const [section, setSection] = useViewSearch(
    "section",
    SECTIONS.map((item) => item.value),
    "rates",
  );
  return (
    <div className="grid gap-6">
      {embedded ? null : (
        <PageHeader
          title="Tax settings"
          description="Tax rates, income brackets, allowances, and jurisdiction lookup for these books."
        />
      )}

      <Tabs
        tabs={SECTIONS}
        value={section}
        onValueChange={setSection}
        label="Tax settings sections"
      >
        {section === "rates" ? <RatesTab /> : null}
        {section === "brackets" ? <BracketsTab /> : null}
        {section === "allowances" ? <AllowancesTab /> : null}
        {section === "lookup" ? <LookupTab /> : null}
      </Tabs>
    </div>
  );
}
